import React from 'react';
import { gql } from '@apollo/client';
import { Datagrid, NumberField, SelectField, SelectInput, TextField } from 'react-admin';
import List from 'components/List';
import IdField from 'components/IdField';
import DateTimeField from 'components/DateTimeField';
import { IdFilter } from 'components/Filter';
import CompanyInput from 'components/CompanyInput';
import LocationInput from 'components/LocationInput';
import ProfessionalInput from 'components/ProfessionalInput';
import { CASE_QUERY_OPTIONS, PermittedLinkField } from 'components/IntegrationCaseFields';

export const STATUS_CHOICES = [
  { id: 'not_started', name: 'Not Started' },
  { id: 'in_progress', name: 'In Progress' },
  { id: 'blocked', name: 'Blocked' },
  { id: 'cleared', name: 'Cleared' },
  { id: 'withdrawn', name: 'Withdrawn' },
];

export const ELIGIBILITY_CHOICES = [
  { id: 'unknown', name: 'Unknown' },
  { id: 'eligible', name: 'Eligible' },
  { id: 'ineligible', name: 'Ineligible' },
];

const OnboardingCaseFilters = [
  <IdFilter />,
  <CompanyInput source="search.company_ids" alwaysOn />,
  <LocationInput alwaysOn />,
  <ProfessionalInput alwaysOn />,
  <SelectInput source="status" choices={STATUS_CHOICES} emptyText="All" alwaysOn />,
  <SelectInput source="eligibility" choices={ELIGIBILITY_CHOICES} emptyText="All" alwaysOn />,
];

const OnboardingCasesList = () => (
  <List
    filters={OnboardingCaseFilters}
    exporter={false}
    queryOptions={CASE_QUERY_OPTIONS}
    data-testid="onboarding-cases-list"
  >
    <Datagrid bulkActionButtons={false} rowClick="show">
      <IdField />
      <TextField label="Case UID" source="uid" sortable={false} />
      <PermittedLinkField
        label="Company"
        source="location.company.name"
        typename="Company"
        sortable={false}
      />
      <PermittedLinkField
        label="Location"
        source="location.name"
        typename="Location"
        sortable={false}
      />
      <PermittedLinkField
        label="Professional ID"
        source="professional_id"
        typename="Professional"
        sortable={false}
      />
      <SelectField source="status" choices={STATUS_CHOICES} sortable={false} />
      <SelectField source="eligibility" choices={ELIGIBILITY_CHOICES} sortable={false} />
      <DateTimeField
        label="Status Effective At"
        source="status_effective_at"
        timeZone="America/Los_Angeles"
      />
      <NumberField label="Revision" source="state_revision" sortable={false} />
      <DateTimeField label="Created At" source="created_at" timeZone="America/Los_Angeles" />
    </Datagrid>
  </List>
);

OnboardingCasesList.query = gql`
  query GET_LIST($input: OnboardingCaseQueryInput) {
    _onboardingCasesMeta(input: $input) {
      count
    }
    onboardingCases(input: $input) {
      id
      uid
      professional_id
      status
      eligibility
      status_effective_at
      state_revision
      created_at
      location {
        id
        name
        company {
          id
          name
        }
      }
    }
  }
`;

export default OnboardingCasesList;
